export default __webpack_public_path__ + "static/media/h-trafego.eb55b6e2.webp";